import React from "react";
import ProductAttributes, { sectionTypes } from "../../../products/ProductAttributes";
import ProductInputContainer from "../ProductInputContainer";

function OtherParameters(props) {
  const productAttributes = new ProductAttributes({ object: props.product, attributes: props.productAttributes, update: props.update });

  return <ProductInputContainer {...props} inputs={productAttributes.getAttributes(sectionTypes.OTHER)} title="product_information.other_parameters"></ProductInputContainer>;
}

export default OtherParameters;
